<template>
  <div class="banSelect">
    <van-notify
      :value="notifyOptions.show"
      :type="notifyOptions.type"
      :style="{marginTop:notifyOptions.marginTop+'px'}"
    >
      <van-icon
        name="bell"
        style="margin-right: 4px;"
      />
      <span>{{ notifyOptions.message }}</span>
    </van-notify>
    <transition
      appear-class="van-fade"
      :enter-class="transition.enterClass"
      :enter-active-class="transition.enterActiveClass"
      :enter-to-class="transition.enterToClass"
      :leave-class="transition.leaveClass"
      :leave-active-class="transition.leaveActiveClass"
      :leave-to-class="transition.leaveToClass"
      v-if="!isPc"
      :mode="transition.mode"
    >
      <keep-alive :include="includeList">
        <router-view class="appBody is-ios-safe-area">
        </router-view>
      </keep-alive>
    </transition>
    <div
      v-else
      :class="['phone_tip',{'is-ios-safe-area-tip':isIOS}]"
    >
      <div>
        请使用手机打开
      </div>
      <p class="beian-footer">© 2026 绿晶小程序 |
        <a
          href="https://beian.miit.gov.cn"
          target="_blank"
        >浙ICP备18033581号</a>
      </p>
    </div>
    <div
      v-if="$loginStatus.isDebug"
      class="debug_bt"
      ref="debugBtRef"
      @click="debugBtPopoverShow=!debugBtPopoverShow"
    >
    </div>
    <nut-popover
      v-model="debugBtPopoverShow"
      position="top"
      :root="$refs.debugBtRef"
    >
      <div>
        <van-field
          label="主管账号"
          disabled
          @click="changeLogin('projectManager')"
          clickable
        ></van-field>
        <van-field
          label="区域综管"
          disabled
          @click="changeLogin('areaChange')"
          clickable
        ></van-field>
        <van-field
          label="区域经理"
          disabled
          @click="changeLogin('areaManager')"
          clickable
        ></van-field>
        <van-field
          label="超级管理员"
          disabled
          @click="changeLogin('superManager')"
          clickable
        ></van-field>
      </div>
    </nut-popover>
  </div>
</template>

<script>
  const localVersion = 2.7

  import BasePage from '@/views/components/BasePage'
  import oldNw from '@/nvwa/version1_0/android'
  import LoginStatusMixin from "@/store/modules/moduleLoginStatus/mixin/LoginStatusMixin";
  import NutPopover from "@/components/NutPopover";
  import Vconsole from 'vconsole'
  const { aplus_queue } = window;

  export default {
    name: "app",
    components: { NutPopover },
    extends: BasePage,
    mixins: [LoginStatusMixin],
    watch: {
      '$route'(to, from) {
        aplus_queue.push({
          action: 'aplus.sendPV',
          arguments: [{ is_auto: false }, {
            page_name: to.fullPath
          }]
        });
        const toDepth = to.meta.index
        const fromDepth = from.meta.index || -1
        if (toDepth >= fromDepth) {
          to.matched.forEach(marchedItem => {
            if (!this.includeAllList.some(item => {
              return item.name === marchedItem.name
            })) {
              this.includeAllList.push(marchedItem)
            }
          })
          this.changeTransition(true)
        } else if (toDepth < fromDepth) {
          this.includeAllList = this.includeAllList.filter(item => {
            return item.meta.index <= toDepth;
          })
          this.changeTransition(false)
        }
        this.includeList = this.includeAllList.map(item => {
          return item.name
        })
        if (fromDepth === toDepth) {
          if (to.meta.subIndex < from.meta.subIndex) {
            this.changeTransition(false)
          }
        }
        if (fromDepth === -1) {
          this.changeTransition(true)
        }
      },
    },
    data() {
      return {
        debugBtPopoverShow: false,
        transition: {
          enterClass: '',
          enterActiveClass: "",
          enterToClass: "",
          leaveClass: "",
          leaveActiveClass: "",
          leaveToClass: "",
          mode: null
        },
        transitionName: "van-slide-right",
        includeAllList: [{
          name: "home",
          meta: {
            index: 1
          }
        }],
        includeList: [],
        appHeight: "",
        isPc: this.$nw.UA.isPc,
        isIOS: this.$nw.UA.isIOS
      }
    },
    computed: {
      notifyOptions() {
        return this.$store.state.windowConfig.notify
      },
    },
    created() {

      if (this.$loginStatus.isDebug) {
        new Vconsole()
      }
      aplus_queue.push({
        action: 'aplus.setMetaInfo',
        arguments: ['globalproperty', { 'UA_TYPE': this.$nw.UA.type, isNvwa: this.$nw.UA.isNvwa }, 'APPEND']
      });
      window.IOSBackClick = false
      this.$nw.hideSystemNavigation()
      // if (localStorage.getItem("localVersion") == null || localStorage.getItem("localVersion") < localVersion) {
      //   localStorage.setItem("localVersion", localVersion)
      //   this.$store.dispatch('loginStatus/logout').then(
      //       () => {
      //         this.$router.replace('/')
      //       }
      //   )
      // }
      this.checkUpdate()
    },
    mounted() {
      let hasLogin = this.$store.getters['loginStatus/hasLogin']()
      console.log("是否登录判断", hasLogin)
      if (hasLogin) {
        let userInfo = this.$store.state.loginStatus.userInfo
        console.log(userInfo, "用户信息")
        setTimeout(() => {
          this.$sendToApp({
            userName: userInfo.userName,
            userNumber: userInfo.userNumber,
            action: 'login', // 可以多加参数方便判断  
            timestamp: new Date().getTime()
          })
        }, 3000)

      }
    },

    beforeDestroy() {
      eventBus.clear()
    },
    methods: {
      changeTransition(enter) {
        if (enter) {
          this.transition = {
            enterClass: 'van-slide-right-enter',
            enterActiveClass: 'van-slide-right-enter-active',
            enterToClass: "van-slide-right-enter-to",
            leaveClass: "van-fade-leave",
            leaveActiveClass: "van-fade-leave-active",
            leaveToClass: "van-fade-leave-to",
            mode: "out-in"
          }
        } else {
          if (this.$nw.UA.isIOS && !IOSBackClick) {
            window.IOSBackClick = false
            this.transition = {
              enterClass: null,
              enterActiveClass: null,
              enterToClass: null,
              leaveClass: null,
              leaveActiveClass: null,
              leaveToClass: null,
              mode: "out-in"
            }
          } else {
            this.transition = {
              enterClass: 'van-fade-enter',
              enterActiveClass: 'van-fade-enter-active',
              enterToClass: "van-fade-enter-to",
              leaveClass: "van-slide-right-leave",
              leaveActiveClass: "van-slide-right-leave-active",
              leaveToClass: "van-slide-right-leave-to",
              mode: "out-in"
            }
          }
        }
      },
      checkUpdate() {
        if (this.$nw.UA.isIOS && this.$nw.UA.isNvwa && !this.$nw.UA.isUniApp) {
          let tipUpdate = () => {
            this.$dialog.alert({
              title: '版本更新提示',
              message:
                '1.完善当前已有功能\n' +
                '2. 升级更新方式，缩小所需安装包体积\n' +
                '3.统一主题，优化使用界面\n' +
                '当前版本更新需到应用中心下载更新'
            }).then(() => {
              // this.checkUpdate()
              // this.$nw.openBrowser({
              //   url: 'https://apps.apple.com/cn/app/%E7%BB%BF%E6%99%B6%E6%9C%8D%E5%8A%A1/id1474938537'
              // })
            });
          }
          tipUpdate()

        }
        if (this.$nw.UA.isOldNvwa && this.$nw.UA.isAndroid) {
          let tipUpdate = () => {
            this.$dialog.alert({
              title: '当前版本必须更新',
              message:
                '1.完善当前已有功能\n' +
                '2. 升级更新方式，缩小所需安装包体积\n' +
                '3.统一主题，优化使用界面\n' +
                '点击确定进入下载界面'
            }).then(() => {
              this.checkUpdate()
              oldNw.openBrowser({
                url: 'https://fir.im/8gzr'
              })
            });
          }

          oldNw.plugin.call('update', { versionName: '2.44' },
            data => {
              if (data.param === "当前已是最新版本") {
                tipUpdate()
                return
              }
              if (parseFloat(data.param) < 3.0) {
                tipUpdate()
              }
            }
          )
        }
        if (this.$nw.UA.isOldNvwa && this.$nw.UA.isIOS) {
          let tipUpdate = () => {
            this.$dialog.alert({
              title: '当前版本必须更新',
              message:
                '1.完善当前已有功能\n' +
                '2. 升级更新方式，缩小所需安装包体积\n' +
                '3.统一主题，优化使用界面\n' +
                '点击确定进入下载界面'
            }).then(() => {
              this.checkUpdate()
              this.$nw.navigateTo({
                url: '/downloadApp'
              })
            });
          }
        }
      },
      deleteFromArray(key, list) {
        let keyIndex = 0
        list.forEach(function (item, index) {
          if (key === item) {
            keyIndex = index
          }
        })
        list.splice(keyIndex, 1)
      },
      onClickLeft() {
        this.$nw.navigateBack()
      },
      changeLogin(bt) {
        let encrypt = (word) => {
          let key = CryptoJS.enc.Utf8.parse("lvjingcleaning12");
          let srcs = CryptoJS.enc.Utf8.parse(word);
          let encrypted = CryptoJS.AES.encrypt(srcs, key, {
            mode: CryptoJS.mode.ECB,
            padding: CryptoJS.pad.Pkcs7
          });
          return encrypted.toString();
        }
        switch (bt) {
          case 'projectManager':
            this.$toast.loading({
              duration: 0
            })
            this.$store.dispatch('loginStatus/login', {
              loginName: '18257118042',
              passWord: encrypt('123456'),
              isActive: 'Y'
            }).then((data) => {
              this.$toast.success()
              if (data.code == 0) {
              } else {
                this.$notify(data.msg)
              }
            }).catch(() => {
              this.$notify('请重试')
            })
            break
          case 'areaChange':
            this.$toast.loading({
              duration: 0
            })
            this.$store.dispatch('loginStatus/login', {
              loginName: '13750830423',
              passWord: encrypt('123456'),
              isActive: 'Y'
            }).then((data) => {
              this.$toast.success()
              if (data.code == 0) {
              } else {
                this.$notify(data.msg)
              }
            }).catch(() => {
              this.$notify('请重试')
            })
            break
          case 'areaManager':
            this.$toast.loading({
              duration: 0
            })
            this.$store.dispatch('loginStatus/login', {
              loginName: '13958161017',
              passWord: encrypt('123456'),
              isActive: 'Y'
            }).then((data) => {
              this.$toast.success()
              if (data.code == 0) {
              } else {
                this.$notify(data.msg)
              }
            }).catch(() => {
              this.$notify('请重试')
            })
            break
          case 'superManager':
            this.$toast.loading({
              duration: 0
            })
            this.$store.dispatch('loginStatus/login', {
              loginName: 'supadmin',
              passWord: encrypt('Lvjing123'),
              isActive: 'Y'
            }).then((data) => {
              this.$toast.success()
              if (data.code == 0) {
              } else {
                this.$notify(data.msg)
              }
            }).catch(() => {
              this.$notify('请重试')
            })
            break
        }
      },
      sendToApp(data) {
        try {
          console.log('准备发送数据:');
          // 检查是否在uni-app的web-view环境中
          if (typeof uni !== 'undefined' && uni.postMessage) {
            console.log(data)
            uni.postMessage({
              data: data
            });
            console.log('数据已通过uni.postMessage发送', data);
          } else {
            console.warn('不在uni-app环境中，无法使用uni.postMessage');
          }
        } catch (error) {
          console.error('发送数据失败:', error);
        }
      }
    }
  }
</script>
<style lang="scss">
.tabbar-ios-safe-area {
  position: fixed;
  bottom: 0;
  height: env(safe-area-inset-bottom);
  width: 100%;
  background: #fff;
}
</style>
<style lang="scss" scoped>
.appBody {
  min-height: 100vh;
  display: flex;
  flex-direction: column;
}
.is-ios-safe-area {
  min-height: calc(100vh - env(safe-area-inset-bottom));
  padding-bottom: env(safe-area-inset-bottom); /* 针对 iOS >= 11.2 */
}
.banSelect {
  -webkit-touch-callout: none;
  -webkit-user-select: none;
  -khtml-user-select: none;
  -moz-user-select: none;
  -ms-user-select: none;
  user-select: none;
}

.phone_tip {
  display: flex;
  flex-direction: column;
  width: 100vw;
  height: 100vh;
  justify-content: center;
  align-items: center;
}
.is-ios-safe-area-tip{
  height:calc(100vh - env(safe-area-inset-bottom));
  padding-bottom: env(safe-area-inset-bottom); /* 针对 iOS >= 11.2 */
  box-sizing: border-box;
}
.beian-footer {
  margin: 0;
  position: fixed;
  bottom: 0;
  left: 0;
  width: 100%;
  text-align: center;
  padding: 8px 0;
  font-size: 12px;
  color: #666;
  background-color: #fff;
  border-top: 1px solid #eee;
  z-index: 999;
}
.debug_bt {
  z-index: 99999;
  width: 40px;
  height: 40px;
  background-color: #00c0a6;
  position: fixed;
  right: 40px;
  bottom: 80px;
}
</style>
